import { motion, AnimatePresence } from "framer-motion";
import Loading from "../../../components/Loading";
import { useFormActaStore } from "../../../store/formActaStore";
import FormActa1 from "../FormActa1";
import FormActa2 from "../FormActa2";
import FormActa3 from "../FormActa3";
import FormActa4 from "../FormActa4";
import { useEffect } from "react";

const FormActa = () => {
  const { loading, /* ultimo_paso, */ defaultValues, setDefaultValues } = useFormActaStore();

  useEffect(() => {
    return () => {
      setDefaultValues(null);
    };
  }, []);

  return (
    <>
      {defaultValues?.ultimo_paso == 0 ? (
        <FormActa1 />
      ) : defaultValues?.ultimo_paso == 1 ? (
        <FormActa2 />
      ) : defaultValues?.ultimo_paso == 2 ? (
        // <FormActa3 />
        <FormActa4 />
      ) : defaultValues?.ultimo_paso == 3 ? (
        <FormActa4 />
      ) : (
        defaultValues?.estado_id == 9 && <>asqeqeqeqwe</>
      )}
    </>
  );
};
export default FormActa;
